// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/authLayout.test.tsx
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import PendingComponent from "../../components/PendingComponent";
import { loginRoute } from "../../routes/login/route";
import { rootRoute } from "../../routes/root/route";
import { store } from "../../utils/store";
import { AskV2Shell } from "../shell/AskV2Shell";

/**
 * Pathless authenticated layout for Ask V2. Reuses login, not PunttLayout —
 * the tickets sidebar must not appear on ask.puntt.ai.
 */
export const askV2AuthLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "ask-v2-authenticated",
  beforeLoad({ location }) {
    const { value: user } = store.getState().auth;
    if (user == null) {
      throw redirect({
        to: loginRoute.to,
        search: {
          redirect: location.pathname,
        },
      });
    }
  },
  component: AskV2AuthLayout,
  pendingComponent: PendingComponent,
});

export function AskV2AuthLayout() {
  return (
    <div data-testid="ask-v2-auth-layout">
      <AskV2Shell />
    </div>
  );
}
